// Always format dates with Latin (Western) digits
const DATE_LOCALE = "en-GB"; // gives "01/02/2026, 14:30" with 24h clock

export function formatDate(input, withTime = false) {
  if (!input) return "—";
  const d = typeof input === "string" ? new Date(input) : input;
  if (isNaN(d.getTime())) return String(input);
  const opts = withTime
    ? { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: false }
    : { year: "numeric", month: "2-digit", day: "2-digit" };
  return d.toLocaleString(DATE_LOCALE, opts);
}

export function formatDateTime(input) {
  return formatDate(input, true);
}

export function formatTime(input) {
  if (!input) return "—";
  const d = typeof input === "string" ? new Date(input) : input;
  if (isNaN(d.getTime())) return String(input);
  return d.toLocaleString(DATE_LOCALE, { hour: "2-digit", minute: "2-digit", hour12: false });
}

export function formatNumber(n) {
  if (n == null || n === "") return "—";
  return Number(n).toLocaleString("en-US");
}
